import React from "react";

const Footer = () => {
  return (
    <div>
      <div className="accent-footer"></div>
      <footer className="page-footer footer text-center" id="footer">
        <small className="footerSpan text-white">
          &copy; 2020 Tauan Longaretti - All rights reserved
        </small>
      </footer>
    </div>
  );
};

export default Footer;
